import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        if (password.length < 8 || !/[A-Za-z]/.test(password) || !/\d/.test(password)) {
            setError("La contraseña necesita al menos 8 caracteres, con letras y números.");
            return;
        }
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success("Contraseña actualizada");
            navigate("/entrar");
        } catch (err) {
            setError(errMsg(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <AuthShell
            title="Crea tu nueva contraseña"
            subtitle="Elige una que puedas recordar."
            footer={<Link to="/entrar" className="font-semibold text-nm-accent">Volver a entrar</Link>}
        >
            {!token ? (
                <p className="rounded-2xl border border-nm-line bg-nm-surface p-6 text-sm text-nm-muted" data-testid="reset-invalid">
                    Este enlace no es válido. Pide uno nuevo desde{" "}
                    <Link to="/recuperar" className="text-nm-accent">recuperar acceso</Link>.
                </p>
            ) : (
                <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
                    <div className="space-y-1.5">
                        <Label htmlFor="password">Nueva contraseña</Label>
                        <Input id="password" type="password" data-testid="reset-password" value={password}
                            onChange={(e) => setPassword(e.target.value)} placeholder="Al menos 8 caracteres" required />
                    </div>
                    {error && <p className="rounded-lg bg-nm-accent-soft px-3 py-2 text-sm text-nm-accent">{error}</p>}
                    <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit">
                        {loading ? "Guardando..." : "Guardar contraseña"}
                    </Button>
                </form>
            )}
        </AuthShell>
    );
}
